/**
 * @flow
 * @format
 */
import React from 'react';
import { PageTemplate as KrispyPageTemplate } from '@krispy/layout/web';
import { withAppManager } from '@ziynx/components/utilities';
import type { ViewportType } from '@ziynx/flow-types/viewports';
import type { ManagedProps } from '@ziynx/flow-types/appManager';
import type { BarStickyType } from '@ziynx/flow-types/layout';
import BarSticky from './BarSticky';

type Props = $ReadOnly<{|
  /**
   * Option to always show rightSlot
   */
  alwaysShowRightSlot?: boolean,
   /**
   * Whether the left slot should have transition effect
   */
  shouldTransition?: boolean,
  /**
   * Root Margin. Default 150px 0 0 0
   */
  rootMargin?: string,
  /**
   * Custom marginLeft for rightSlot
   */
  rightSlotMarginLeft?: string,
  /**
   * Optional height for left col
   */
  height?: number | string,
  /**
   * Customized width when nav expands
   */
  leftColWidth?: string,
  /**
   * Viewports
   */
  viewport?: ViewportType,
  /**
   * Allotted left slot
   */
  leftSlot: React$Node,
  /**
   * Content well for left slot
   */
  leftContent: React$Node,
  /**
   * Allotted right slot
   */
  rightSlot: React$Node,
  /**
   * BarSticky or other Sticky Header component
   */
  stickyHeader?: BarStickyType,
  /**
   * Sticky Header offset aka when to toggle stuck
   */
  headerOffset?: number,
  /**
   * Allotted right slot
   */
  onSlotShown?: (rightSlotShowing: boolean) => void,
  |}>;

function PageTemplate(props: ManagedProps<Props>): React$Node {
  const {
    stickyHeader,
    onSlotShown = () => {},
    headerOffset,
    ...rest
  } = props;
  const renderStickyHeader = ({ headerStuck, viewport: viewportKrispy }): React$Node => (
    <BarSticky
      {...rest}
      {...stickyHeader}
      viewport={viewportKrispy}
      isStuck={headerStuck}
      isVisible={headerStuck}
    />
  );
  return (
    <KrispyPageTemplate
      {...rest}
      renderStickyHeader={stickyHeader ? renderStickyHeader : undefined}
      headerOffset={headerOffset}
      onSlotShown={onSlotShown} // Removes error in appending invalid handler to div for BarSticky
    />
  );
}

PageTemplate.defaultProps = {
  rootMargin: '150px 0px 0px 0px',
};

export default (withAppManager(PageTemplate): React$ComponentType<
  React$Config<ManagedProps<Props>, typeof PageTemplate.defaultProps>
>);
